module.exports = __webpack_public_path__ + "static/media/giftIcon.804ad579.svg";